import FastingTimerBody from './FastingTimerBody';

export default FastingTimerBody;
